var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"topheader"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("Klaar voor kinderen?")])]),_c('div',{staticClass:"infobutton",on:{"click":_vm.openCloseInfoScreen}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }